import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { FileUtil } from '../../utils/file-util/file-util';

@Pipe({
	name: 'formatFileSize',
	standalone: true,
})
@Injectable({
	providedIn: 'root',
})
export class FormatFileSizePipe implements PipeTransform {
	transform(bytes: number): string {
		return FileUtil.formatFileSize(bytes);
	}
}
